import React from 'react';
import {
  Paper,
  Typography,
  Box,
} from '@mui/material';
import RelationalChart from '../charts/RelationalChart';

const RelationalTab = ({
  searchResults,
  searchParams,
  tierInfo,
  resultsFilter,
  forceViewMode,
  onClearMapSelection,
  onRegisterClearCallback,
  onZoomToData,
  onRegisterNavigateToLeaseInSummary,
  navigateToLeaseInMapRef,
}) => {
  // Don't render if no search results
  if (!searchResults) return null;

  // Check if we have any data to show relationships
  const hasData = searchResults.data && (
    (searchResults.data.wells && searchResults.data.wells.length > 0) ||
    (searchResults.data.production && searchResults.data.production.length > 0) ||
    (searchResults.data.inspections && searchResults.data.inspections.length > 0) ||
    (searchResults.data.violations && searchResults.data.violations.length > 0) ||
    (searchResults.data.severances && searchResults.data.severances.length > 0) ||
    (searchResults.data.spills && searchResults.data.spills.length > 0)
  );

  if (!hasData) {
    return (
      <Paper sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="h6" color="text.secondary">
          No Data Available
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Search for data to see relationships between different data types.
        </Typography>
      </Paper>
    );
  }

  return (
    <Box>
      {/* Relational Chart */}
      <RelationalChart 
        searchResults={searchResults} 
        searchParams={searchParams} 
        resultsFilter={resultsFilter} 
        forceViewMode={forceViewMode}
        onClearMapSelection={onClearMapSelection}
        onRegisterClearCallback={onRegisterClearCallback}
        onZoomToData={onZoomToData}
        onRegisterNavigateToLeaseInSummary={onRegisterNavigateToLeaseInSummary}
        navigateToLeaseInMapRef={navigateToLeaseInMapRef}
      />
    </Box>
  );
};

export default RelationalTab;





